import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

/**
 * `/master/rob/rob` — CRUD record ROB. Semua method balikin response axios UTUH,
 * jalur bacanya `res.data.data`.
 */
const master = {
  get(config) {
    return axiosInstance.get('/master/rob/rob', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  create(data) {
    return axiosInstance.post('/master/rob/rob', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  delete(id, config) {
    return axiosInstance.delete(`/master/rob/rob/${id}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  update(id, data, config) {
    return axiosInstance.put(`/master/rob/rob/${id}`, data, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
};

/**
 * `/summary/rob/{mrobId}` — summary satu record ROB. Balikin response axios UTUH,
 * jalur bacanya `res.data.data`.
 *
 * Ditolak izin dibalas HTTP 200 + `status.errorCode` 412 di body, jadi axios gak throw
 * dan pemanggil ngecek manual sebelum baca `data`
 * (src/views/RemainOnBoard/Index.vue:158 dan :206). `status.message` udah siap tampil
 * apa adanya.
 *
 * Param yang dikirim halaman: `{ interval, debugRob: 1 }` lewat `config.params`.
 */
const summary = {
  get(mrobId, config) {
    return axiosInstance.get(`/summary/rob/${mrobId}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
};

/**
 * `/master/rob/adjustment` — CRUD adjustment. Balikin response axios UTUH, jalur
 * bacanya `res.data.data`.
 *
 * Difilter per record ROB pakai konvensi baru `finds[kolom]`, bukan
 * `?findField=&findValue=`: `{ params: { 'finds[robaMrobId]': mrobId } }`
 * (src/views/RemainOnBoard/Index.vue:176).
 */
const adjustment = {
  get(config) {
    return axiosInstance.get('/master/rob/adjustment', {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  create(data) {
    return axiosInstance.post('/master/rob/adjustment', data, {
      cancelToken: getNewCancelToken(),
    });
  },
  delete(id, config) {
    return axiosInstance.delete(`/master/rob/adjustment/${id}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  update(id, data, config) {
    return axiosInstance.put(`/master/rob/adjustment/${id}`, data, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
};

export default {
  master,
  summary,
  adjustment,
};
